import { render } from "./officialAccountsCodeList.vue?vue&type=template&id=3bf4483c&scoped=true"
import script from "./officialAccountsCodeList.vue?vue&type=script&lang=js"
export * from "./officialAccountsCodeList.vue?vue&type=script&lang=js"

import "./officialAccountsCodeList.vue?vue&type=style&index=0&id=3bf4483c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf4483c"]])

export default __exports__